import React from 'react';

import HtmlParser from 'react-html-parser';
import { useSelector } from 'react-redux';

import styles from '../SingleInputPage/SingleInputPage.module.scss';
import { NoWorkshopViewContainer, SuggestButton } from './styled';

export default function NoWorkshopView({ hideSuggestButton, onSuggest }) {
  const noWorkshopErrorMessage = useSelector(
    (store) => store.data.noWorkshopErrorMessage,
  );
  const noSummerplayErrorMessage = useSelector(
    (store) => store.data.noSummerplayErrorMessage,
  );

  return (
    <NoWorkshopViewContainer>
      <p
        style={{ padding: '0 16px', textAlign: 'center' }}
        className={styles.errorMessage}
      >
        {HtmlParser(
          !hideSuggestButton
            ? noWorkshopErrorMessage
            : noSummerplayErrorMessage,
        )}
      </p>
      {!hideSuggestButton && <SuggestButton onClick={onSuggest} />}
    </NoWorkshopViewContainer>
  );
}
